import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z", fill: "#F2F2F2" }));
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
